var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reminder-ribbon"},[_c('div',{staticClass:"reminder-ribbon-label"},[_c('span',{staticStyle:{"font-size":"10px !important"}},[_vm._v("CUSTOMER LOCAL TIME")]),_c('p',{staticClass:"text-center",staticStyle:{"font-size":"16px !important","height":"20px"}},[_vm._v(_vm._s(_vm.customerLocalTime))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }